var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBadge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 28,
    fill: "#F0FAFF"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C0E8FB",
    d: "M28 5C15.297 5 5 15.297 5 28s10.297 23 23 23 23-10.297 23-23S40.703 5 28 5zm0 2c11.598 0 21 9.402 21 21s-9.402 21-21 21S7 39.598 7 28 16.402 7 28 7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#97D8F7",
    d: "M24.176 24.072l-4.397.632-.151.027c-1.59.342-2.2 2.34-.994 3.497l3.172 3.05-.75 4.307-.02.153c-.165 1.616 1.564 2.79 3.03 2.024L28 35.72l3.938 2.042.138.066c1.48.641 3.153-.602 2.869-2.243l-.751-4.308 3.174-3.05.107-.111c1.092-1.208.397-3.177-1.254-3.413l-4.397-.632-1.963-3.928c-.764-1.522-2.955-1.529-3.72 0l-1.964 3.928zm3.896-3.032l2.43 4.862 5.434.782c.061.009.08.067.045.102l-3.94 3.788.932 5.354c.008.044-.057.09-.115.06L28 33.468l-4.858 2.52c-.059.03-.123-.015-.115-.06l.932-5.354-3.94-3.788c-.035-.035-.016-.093.045-.102l5.434-.782 2.43-4.864c.027-.051.117-.051.144.002z"
  }))));
}

export default SvgBadge;